import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    SkipSelf,
} from '@angular/core';
import {
    ControlContainer,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TooltipComponent } from '../tooltip/tooltip.component';

@Component({
    selector: 'input-general',
    templateUrl: './input-general.component.html',
    styleUrls: ['./input-general.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule,
        TooltipComponent,
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
})
export class InputGeneralComponent implements OnChanges {
    @Input() label: string | null = null;
    @Input() currentValue: string = '';
    @Input() placeHolder: string = '';
    @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();
    @Input() mandatoryField: boolean = false;
    @Input() inputType: string = 'text';
    @Input() hideInput: boolean = false;
    @Input() resetPasswordButton: boolean = false;
    @Input() resetMobileButton: boolean = false;
    @Input() verifyMobileButton: boolean = false;
    @Input() resetMobileTooltipData = {
        header: '',
        content: '',
    };
    @Input() verifyMobileTooltipData = {
        header: '',
        content: '',
    };
    @Input() class: string = '';
    @Input() removeValue: boolean = false;
    @Input() errors: string[] = [];
    @Input() strength: null | number = null;
    @Input() strengthLabel: null | string = null;
    @Input() strengthColor: string = '#4b6eec';
    @Input() classOverrides: string | null = null;
    @Input() controlName?: string;
    @Input() maxlength: any;
    @Input() phoneNoCodeLabel?: string = undefined;
    @Output() phoneNoFieldChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() resetMobile: EventEmitter<any> = new EventEmitter<any>();
    @Output() verifyMobile: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() resetPassword: EventEmitter<any> = new EventEmitter<any>();
    strengthArray = [0, 1, 2, 3];

    hide: boolean;
    hideResetPasswordButton: boolean;
    hideResetMobileButton: boolean;
    verifyMobileTooltip: boolean = false;
    resetMobileTooltip: boolean = false;
    isFocus: boolean = false;
    showCloseIcon: boolean = false;
    inputValue: string = '';

    constructor(public router: Router, public translate: TranslateService) {
        this.hide = this.hideInput; // Set the initial value of hide based on hideInput
        this.hideResetPasswordButton = this.resetPasswordButton;
        this.hideResetMobileButton = this.resetMobileButton;
    }

    toggleHideInput() {
        this.hide = !this.hide;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.hideInput?.currentValue === true) {
            this.hide = true;
        }
    }

    resetPass() {
        this.resetPassword.emit(true);
    }

    resetMobilePhone() {
        this.resetMobileTooltip = false;
        this.resetMobile.emit(true);
        this.resetMobileButton = false;
    }

    afterResetMobilePhone() {
        this.hideResetMobileButton = false;
    }

    verifyMobilePhone() {
        this.verifyMobileTooltip = false;
        this.verifyMobile.emit(true);
    }

    updateCloseIconVisibility() {
        // this.showCloseIcon = this.controlName.trim().length > 0 && this.isFocus;
    }

    onFocus() {
        this.isFocus = true;
        this.updateCloseIconVisibility();
    }

    onBlur() {
        setTimeout(() => {
            this.isFocus = false;
            this.updateCloseIconVisibility();
        }, 0);
    }

    onInputChange() {
        this.updateCloseIconVisibility();
    }

    clearInput() {
        this.controlName = '';
        this.showCloseIcon = false;
    }
}
